import { clamp } from 'lodash';
import { CoreAPI, ICore } from '@/framework/core';
import { IStage, StageAPI } from '@/framework/stage';
import { getLayerOperateState } from '../states/layer-operate-state';

export class StageScroll {
    private frameworkStage: IStage;
    private frameworkCore: ICore;

    constructor(private identity: string) {
        this.frameworkStage = StageAPI(identity);
        this.frameworkCore = CoreAPI(identity);
    }

    /** 滚动到指定舞台 */
    scrollTo(index: number, delActiveLayer = true) {
        if (delActiveLayer) {
            getLayerOperateState(this.identity).delActiveLayer(true);
        }
        const stageScrollbar = document.querySelector(`#${this.identity}ScrollContainerWrap`);
        if (!stageScrollbar) return;

        const stageList = this.frameworkCore.getRenderStage();
        if (!stageList.length) return;

        const scale = this.frameworkStage.getScale();

        index = clamp(index, 0, stageList.length - 1);

        const stageTop = this.frameworkCore.getStageTop(index);
        stageScrollbar.scrollTo({
            top: stageTop * scale,
            behavior: 'smooth',
        });
    }

    /** 滚动到激活舞台 */
    scrollToActiveStage(delActiveLayer = true) {
        // setTimeout(() => {
        const activeStageIndex = this.frameworkStage.getActiveStageIndex();
        this.scrollTo(activeStageIndex, delActiveLayer);
        this.frameworkCore.events.emitStageScrollTop();
        // }, 0);
    }
}
